/** @jsx jsx */
/** @jsxFrag null */
import {jsx} from 'panel';
import {selx} from 'clsx';

import {ButtonAttrs, ButtonEl} from 'common/components/button';
import {InputAttrs, InputEl} from 'common/components/input';
import {ButtonTheme} from 'common/components/button/constants';

import {Necessary, ValidationStatus} from '../input/types';
import type {InputGroup} from './index';
import overrides from './override.inline.styl';
import styles from './index.module.styl';

export function template(this: InputGroup) {
  const {value, errors} = this.state;

  const disabled = this.attr(`disabled`);
  const readOnly = this.attr(`readonly`);
  const theme = this.attr(`theme`);
  const busy = this.attr(`busy`);
  const maxLength = this.attr(`maxlength`);
  const minLength = this.attr(`min`);

  const inputAttrs: InputAttrs = {
    placeholder: this.attr(`placeholder`),
    necessary: Necessary.Required,
    ...(maxLength ? {maxlength: maxLength} : {}),
    ...(minLength ? {min: minLength.toString()} : {}),
    'validation-status': errors.length > 0 ? ValidationStatus.Invalid : ValidationStatus.Default,
    'error-message': this.helpers.getErrorMessage(),
  };
  const buttonAttrs: Partial<ButtonAttrs> = {
    disabled: disabled || !this.helpers.isValid(),
    theme: ButtonTheme.Primary,
  };

  if (disabled || busy) {
    inputAttrs.disabled = true;
  }

  if (readOnly) {
    inputAttrs.readonly = true;
  }

  if (theme) {
    buttonAttrs.theme = theme;
  }

  if (this.attr(`icon`) || this.attr(`busy`)) {
    buttonAttrs.icon = this.attr(`busy`) ? `spinner` : this.attr(`icon`);
  }

  return (
    <div sel={selx(styles.mpInputGroupContainer)} attrs={{elref: `input-group-container`}}>
      <InputEl
        sel={selx(styles.mpInputGroupInput)}
        attrs={{elref: `input-group-input`, ...inputAttrs, 'style-override': overrides}}
        props={{value}}
        on={{
          input: this.helpers.setValue,
          keyup: this.helpers.submitIfEnter,
          blur: this.helpers.checkErrors,
          focus: this.helpers.handleFocus,
        }}
      />
      <ButtonEl sel={selx(`mp-button`, styles.mpInputGroupBtn)} attrs={buttonAttrs} on={{click: this.helpers.submit}}>
        {this.attr(`busy`) ? null : this.attr(`label`)}
      </ButtonEl>
    </div>
  );
}
